var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiRecruiterIcon = function SvgAiRecruiterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "m160 256-64-32c-8-4-8-16 0-20l64-32 32-64c4-8 16-8 20 0l32 64 64 32c8 4 8 16 0 20l-64 32-32 64c-4 8-16 8-20 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "m384 128-32-16-16-32c-2-4-8-4-10 0l-16 32-32 16c-4 2-4 8 0 10l32 12 16 36c2 4 8 4 10 0l16-36 32-12c4-2 4-8 0-10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "m368 320-32-12-16-36c-2-4-8-4-10 0l-16 36-32 12c-4 2-4 8 0 10l32 12 16 36c2 4 8 4 10 0l16-36 32-12c4-2 4-8 0-10"
  })));
};
export default SvgAiRecruiterIcon;